export enum ORDER_CONST {
  TEST_ID = 'order-success',
}

export type OrderWrapperProps = {
  children: ReactNode;
};
